import React, { Component, useMemo } from 'react';
import Collapsible from 'react-collapsible';
import {
  FaCheck,
  FaPause,
  FaSortDown,
  FaSortUp,
  FaTimes
} from 'react-icons/fa';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import api from '../../axios-local-api';
import Box from '../../hoc/Box/Box';
import Spinner from '../../components/UI/Spinner/Spinner';
import Confirm from '../../components/UI/Confirm/Confirm';
import Error from '../../components/UI/Error/Error';
import Modal from '../../components/UI/Modal/Modal';
import Success from '../../components/UI/Success/Success';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import { sortDataByProperty } from '../../shared/utility';
import * as actions from '../../store/actions/index';
import classes from './CreateGroup.css';
import ErrorAlert from '../../shared/Alert/ErrorAlert';
import { getDeviceName, getDeviceModel, getDevicePauseStatus,
  getDeviceSignalStatus, isGroupNameExist, getGroupMap
} from '../../shared/common';


class CreateGroup extends Component {
  constructor(props) {
    super(props);
    this.devicesInterval = 12;
    this.state = {
      upArrow: false,
      groupName: '',
      deviceMacs: new Map(),
      isInvalidGroupName: false,
      isWarning: false,
      groupNameError: '',
      currentDevicesLength: this.devicesInterval,
      confirmModal: false,
      currentRecords: null,
      sortBy: '',
      sortDirection: '',
      isFocused: false
    };
    this.cancelGroupName = this.cancelGroupName.bind(this);

  }

  componentWillReceiveProps(nextProps, prevState) {

    if (!prevState.currentRecords && nextProps.devicesByEquipment && nextProps.devicesByEquipment.length > 0) {
      this.setState({
        currentRecords: this.buildCurrentGroupData(nextProps.devicesByEquipment),
        sortDirection: 'asc'
      }, () => {
        this.sortTable('deviceSignalStatus'); //Use async await instead of callback function
      })
    }
  }
  componentDidMount() {
    this.timerId = setInterval(() => {
      if (this.props.devicesByEquipment) { // it should be devicesByEquipment.length as devicesByEquipment is an array

        let deviceMacs = this.props.devicesByEquipment.map(d => d.mac);

        if (deviceMacs.length > 0) {
          clearInterval(this.timerId);
          this.props.onGetAdvancedDeviceIds(deviceMacs);
        }
      }
    }, 500);
  }


  onOpenModal = (result, action) => {
    this.setState({
      confirmModal: true,
      result: result,
      action: action,
    });
  };
  confirmModalConfirmHandler = () => {
    let selectedMacs = [];
    this.state.deviceMacs.forEach((checked, mac) => {
      if (checked === true) {
        selectedMacs.push(mac);
      }
    });

    let deviceGroup = {
      nickname: this.state.groupName.trim(),
      imageId: ' ',
      assignedDevices: selectedMacs,
    };

    this.props.onCreateDeviceGroup(deviceGroup);

    this.confirmModalCancelHandler('close');
  };

  confirmModalCancelHandler = () => {
    this.setState({
      confirmModal: false,
      groupName: '',
      deviceMacs: new Map(),
      isInvalidGroupName: false
    });
  };

  openHandler() {
    this.setState({
      upArrow: true,
    });
  }
  closeHandler() {
    this.setState({
      upArrow: false,
    });
  }

  handleClick = () => {
    this.setState({
      currentDevicesLength:
        this.state.currentDevicesLength + this.devicesInterval,
    });
  };

  handleGroupNameChange = (e) => {
    let name = e.target.value;
    this.setState({
      groupName: name,
    });
    const spaceError = 'Space is only allowed in between the characters.'; //The following characters are not allowed $ {"<"} > ` \ ^ & ; "
    if (name.length === 0) {
      this.setState({ isInvalidGroupName: true, isWarning: false, groupNameError: 'Empty name is not allowed' })
    } else if (name.trim() === '') {
      this.setState({ isInvalidGroupName: true, isWarning: false });
    } else if (!(/^[^<>]+$/.test(name.trim()))) {
      this.setState({ isInvalidGroupName: true, isWarning: false, groupNameError: 'Special Characters are not allowed <>.' })
    } else if (/^\s|\s{}|\s$/.test(name)) {
      this.setState({ isInvalidGroupName: true, isWarning: false, groupNameError: spaceError })
    } else if (/\s{2,}/g.test(name)) {
      this.setState({ isInvalidGroupName: true, isWarning: false, groupNameError: 'Space is only allowed in between the characters.' })

    } else if (isGroupNameExist(this.props.groups, name)) {
      this.setState({ isInvalidGroupName: true, isWarning: false, groupNameError: 'Group Name entered already exists' })
    } else if (name.length >= 30) {
      this.setState({ isInvalidGroupName: true, isWarning: true, groupNameError: 'Max Character Limit Reached' })
    } else if (this.props.loading) {
      this.setState({ isInvalidGroupName: true, isWarning: true })
    } else {
      this.setState({ isInvalidGroupName: false, isWarning: false })
    }
  };

  handleDeviceCheckBox = (e) => {
    let deviceMac = e.target.value;
    let checked = e.target.checked;
    this.setState(
      (prevState) => {
        return {
          deviceMacs: prevState.deviceMacs.set(deviceMac, checked),
        };
      });
  };

  successErrorResetHandler = () => {
    if (this.props.createDeviceGroupSuccess) {
      this.setState(
        (prevState) => {
          let deviceMacs = prevState.deviceMacs;
          deviceMacs.forEach((mac) => {
            deviceMacs.set(mac, false);
          });
          return {
            groupName: '',
            isInvalidGroupName: false,
            deviceMacs: prevState.deviceMacs,
          };
        },
        () => {
        }
      );
    }
    this.props.onResetCreateDeviceGroupSuccessError();
  };

  getDeviceSignalStatus = (device, deviceSignalStatus, colorCode) => {

    let colorDot;
    if (deviceSignalStatus === 'Calculating') {
      colorDot = (
        <div
          className={classes.colorDot}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <div className={classes.Calculating}></div>
          <div style={{ width: '10px' }} />
          <div style={{ color: colorCode.calculating }}>{deviceSignalStatus}</div>
        </div>
      );
    } else if (
      device?.connectionState === 'connected' &&
      device?.freeze.frozen === true
    ) {
      colorDot = (
        <div
          className={classes.colorDot}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <div className={classes.Paused}></div>
          <div style={{ width: '10px' }} />
          <div>Paused</div>
        </div>
      );
    } else if (
      device?.connectionState === 'connected' &&
      device?.capabilities
    ) {
      colorDot = (
        <div
          className={classes.colorDot}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <div
            className={
              deviceSignalStatus === 'Poor' || deviceSignalStatus === 'Fair' ? classes.NotConnected : classes.Connected
            }
          ></div>
          <div style={{ width: '10px' }} />
          <div
            style={{
              color: deviceSignalStatus === 'Poor' || deviceSignalStatus === 'Fair' ? colorCode.poor : colorCode.connected,
            }}
          >
            {deviceSignalStatus}
          </div>
        </div>
      );
    } else if (
      device?.connectionState === 'connected' &&
      !device?.capabilities
    ) {
      colorDot = (
        <div
          className={classes.colorDot}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <div className={classes.NotConnected}></div>
          <div style={{ width: '10px' }} />
          <div styles={{ color: colorCode.disconnected }}>{deviceSignalStatus}</div>
        </div>
      );
    } else {
      colorDot = (
        <div
          className={classes.colorDot}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <div className={classes.NotConnected}></div>
          <div style={{ width: '10px' }} />
          <div style={{ color: colorCode.poor }}>Disconnected</div>
        </div>
      );
    }
    return colorDot;
  };

  sortTable = (propertyName) => {
    const { sortDirection, currentRecords } = this.state;
    let groupMap = getGroupMap(this.props.groups);
    const records = sortDataByProperty(
      currentRecords.map((device) => ({
        ...device,
        groupName: device.mac in groupMap ? groupMap[device.mac] : 'UnGrouped',
      })),
      propertyName,
      sortDirection
    );
    this.setState({
      currentRecords: records,
      sortDirection:
        sortDirection === '' || sortDirection === 'desc' ? 'asc' : 'desc',
      sortBy: propertyName,
    });
  };

  buildCurrentGroupData = (deviceData = []) => {
    if (!deviceData) return null;
    const copydevice = [...deviceData];
    let groupMap = getGroupMap(this.props.groups);
    
    return copydevice.map((device) => {
      device.groupName =
        device.mac in groupMap ? groupMap[device.mac] : 'UnGrouped';
      let { deviceName } = getDeviceName(device, this.props.advancedDeviceIds);
      if (deviceName && deviceName.length > 12) {
        deviceName = deviceName.substring(0, 12) + '...';
      }
      const { deviceSignalStatus} = getDeviceSignalStatus(device);
      let deviceModel = getDeviceModel(device.mac, '', this.props.advancedDeviceIds);
      let devicePause = getDevicePauseStatus(device);
      device.deviceName = deviceName;
      device.deviceModel = deviceModel;
      device.deviceSignalStatus = deviceSignalStatus;
      device.paused = devicePause;
      return device;
    });
  };

  getDeviceRow = (device, groupName, hideDeviceName = false) => {
    let { deviceName } = getDeviceName(device, this.props.advancedDeviceIds);
    if (deviceName && deviceName.length > 12) {
      deviceName = deviceName.substring(0, 12) + '...';
    }
    const { deviceSignalStatus, colorCode} = getDeviceSignalStatus(device);
    let deviceModel = getDeviceModel(device.mac, '', this.props.advancedDeviceIds);
    let deviceSignal = this.getDeviceSignalStatus(device, deviceSignalStatus, colorCode);
    let devicePause = getDevicePauseStatus(device);
    devicePause = devicePause === 'pause' ? <FaPause color={'gray'} /> : '';

    let nameStyle, commonStyle = {
      padding: '20px',
      borderRight: 'none',
      borderLeft: 'none',
    };
    if (hideDeviceName) {
      nameStyle = { display: 'none', ...nameStyle };
    } else {
      nameStyle = { display: 'flex', ...nameStyle };
    }

    return (
      <tr style={{ borderBottom: '1px solid lightgray' }}>
        <td style={nameStyle}>
          <input
            id="CreateGroupDeviceCheckbox"
            type="checkbox"
            className={classes.DeviceCheckBox}
            checked={
              this.state.deviceMacs.get(device.mac) === null
                ? false
                : this.state.deviceMacs.get(device.mac)
            }
            name={device.mac}
            value={device.mac}
            onClick={this.handleDeviceCheckBox}
          />
          <span
            id="DeviceName"
            style={{
              marginLeft: '10px',
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
              width: '140px',
              paddingTop: '5.5px'
            }}
          >
            {deviceName}
          </span>
        </td>
        <td
          id="DeviceSignal"
          style={{
            ...commonStyle,
            whiteSpace: 'pre',
          }}
        >
          {deviceSignal}
        </td>
        <td
          style={{
            ...commonStyle,
            padding: '10px',
            width: '100px',
          }}
        >
          <span className={classes.DeviceModelCss} id="DeviceModel">
            {deviceModel}
          </span>
        </td>
        <td
          id="CurrentGroup"
          style={{
            ...commonStyle,
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap',
            width: '140px',

          }}
        >
          {groupName}
        </td>
        <td
          id="DevicePause"
          style={{
            ...commonStyle,
            whiteSpace: 'pre',
            textAlign: 'center'
          }}
        >
          {devicePause}
        </td>
      </tr>
    );
  };

  getDeviceNameRow = (device) => {
    let {deviceName} = getDeviceName(device, this.props.advancedDeviceIds);
    if (deviceName && deviceName.length > 12) {
      deviceName = deviceName.substring(0, 12) + '...';
    }

    return (
      <Box>
        <tr>
          {' '}
          <td
            style={{
              display: 'flex',
              padding: '20px',
              borderRight: 'none',
              borderLeft: 'none',
            }}
          >
            <input
              type="checkbox"
              className={classes.DeviceCheckBoxForMobile}
              checked={
                this.state.deviceMacs.get(device.mac) === null
                  ? false
                  : this.state.deviceMacs.get(device.mac)
              }
              name={device.mac}
              value={device.mac}
              onClick={this.handleDeviceCheckBox}
            />
            <span
              style={{
                marginLeft: '10px',
                paddingTop: '11px',
                overflowWrap: 'break-word',
                whiteSpace: 'normal',
                width: '140px',
              }}
              className={[classes.devName, classes.RegularButtonForMobile].join(
                ' '
              )}
            >
              {deviceName}
            </span>
          </td>{' '}
        </tr>
      </Box>
    );
  };

  getDeviceRows = (groupMap, hideDeviceName) => {
    if (!this.state.currentRecords) {
      return [];
    }
    return ( this.state?.currentRecords.map((device) => {
        let groupName =
          device.mac in groupMap ? groupMap[device.mac].nickname : 'UnGrouped';
        return this.getDeviceRow(device, groupName, hideDeviceName);
      })
    );
  };

  getDeviceNameRows = () => {
    if (!this.state.currentRecords) {
      return [];
    }
    return (
      this.state.currentRecords.map((device) => {
        return this.getDeviceNameRow(device);
      })
    );
  };

  hasDevicesFromExistingGroupsSelected = (selectedMacs) => {
    let existingGroups = selectedMacs.filter(
      (mac) =>
        mac in this.state.groupMap && this.state.groupMap[mac] !== 'UnGrouped'
    );
    return existingGroups.length > 0;
  };

  createGroupHandler = () => {
    let selectedMacs = [];
    let modalContent;
    this.state.deviceMacs.forEach((checked, mac) => {
      if (checked) {
        selectedMacs.push(mac);
      }
    });
    if (selectedMacs.length > 0) {
      modalContent = (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <h2>Are you sure?</h2>
          <p
            style={{ fontWeight: 'normal', textAlign: 'center', margin: '2px' }}
          >
            Device(s) being assigned to a new group will lose their current
            pause schedule.
          </p>
          <p
            style={{ fontWeight: 'normal', textAlign: 'center', margin: '5x' }}
          >
            Are you sure you want to proceed?
          </p>
        </div>
      );
    } else {
      modalContent = (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <h2>Creating a new group? </h2>
          <p
            style={{ fontWeight: 'normal', textAlign: 'center', margin: '2px' }}
          >
            You have not added devices to this group.
          </p>
          <p
            style={{ fontWeight: 'normal', textAlign: 'center', margin: '5px' }}
          >
            Are you sure you want to proceed?
          </p>
        </div>
      );
    }

    this.onOpenModal(modalContent);
  };

  shouldDisplayShowMoreLink = () => {
    if (!this.props.devicesByEquipment || (this.state.currentDevicesLength > this.props.devicesByEquipment.length)) {
      return false;
    }
    return true;
  };

  getDevicesTable = (targetView) => {
    let sortIcon;
    const { sortDirection, sortBy } = this.state;
    if (sortDirection === 'desc') {
      sortIcon = <FaSortUp fontSize={'18px'} />;
    } else if (sortDirection === 'asc') {
      sortIcon = <FaSortDown fontSize={'18px'} />;
    }
    let groupMap = getGroupMap(this.props.groups);
    if(this.props.apiNotFound) {
      return <ErrorAlert />
    }

    if (
      this.props.createDeviceGroupLoading ||
      this.props.loading ||
      this.props.devicesByEquipmentLoading ||
      this.props.adidLoading ||
      (this.props.wan?.checkingWan)
    ) {
      return <Spinner />;
    }
    if(this.props.errorStatus) {
      return (<ErrorAlert />)
    }
    if (!this.state.currentRecords) {
      return (
        <div className={classes.tablewrapper}>
          <div id= 'createGroupNoDevice' style={{ color: 'gray', textAlign: 'center' }}>
            There is no Device Information available at this time
          </div>
          <div className={classes.Spacer} />
        </div>
      );
    }
    let tableForDesktop = (
      <div className={classes.tablewrapper}>
        <table className={classes.devTable} cellPadding="0" cellSpacing="0" style={{ borderCollapse: 'collapse' }}>
          <thead>
            <tr className={classes.trTag} style={{ borderBottom: '1px solid lightgray' }}>
              <th
                style={{
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'left',
                  padding: '20px',
                  color: 'grey',
                }}
                onClick={() => {
                  this.sortTable('deviceName');
                }}
              >
                Device Name {sortBy === 'deviceName' && sortIcon}
              </th>

              <th
                style={{
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'left',
                  padding: '20px',
                  color: 'grey',
                }}
                onClick={() => {
                  this.sortTable('deviceSignalStatus');
                }}
              >
                Signal {sortBy === 'deviceSignalStatus' && sortIcon}
              </th>

              <th
                style={{
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'left',
                  padding: '20px',
                  color: 'grey',
                }}
                onClick={() => {
                  this.sortTable('deviceModel');
                }}
              >
                Device Model {sortBy === 'deviceModel' && sortIcon}
              </th>
              <th
                style={{
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'left',
                  padding: '20px',
                  color: 'grey',
                }}
                onClick={() => {
                  this.sortTable('groupName');
                }}
              >
                Current Group {sortBy === 'groupName' && sortIcon}
              </th>
              <th
                style={{
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'center',
                  padding: '20px',
                  color: 'grey',
                }}
                onClick={() => {
                  this.sortTable('paused');
                }}
              >
                Pause {sortBy === 'paused' && sortIcon}
              </th>
            </tr>
          </thead>
          <tbody>
            {this.getDeviceRows(groupMap, false)}
          </tbody>
        </table>
      </div>
    );

    let table1 = this.getDevicesNameTable();
    let table2 = (
      <div className={classes.tablewrapper}>
        <table
          className={classes.devTable}
          style={{ borderBottom: '1px solid lightgray' }}
          cellPadding="0"
          cellSpacing="0"
        >
          <thead>
            <tr className={classes.trTag}>
              <th
                className={classes.thTag}
                // style={{ borderBottom: '1px solid lightgray' }}
                onClick={() => {
                  this.sortTable('deviceSignalStatus');
                }}
              >
                Signal {sortBy === 'deviceSignalStatus' && sortIcon}
              </th>
              <th
                className={classes.thTag}
                // style={{ borderBottom: '1px solid lightgray' }}
                onClick={() => {
                  this.sortTable('deviceModel');
                }}
              >
                Device Model {sortBy === 'deviceModel' && sortIcon}
              </th>
              <th
               className={classes.thTag}
              //  style={{ borderBottom: '1px solid lightgray' }}
                onClick={() => {
                  this.sortTable('groupName');
                }}
              >
                Current Group {sortBy === 'groupName' && sortIcon}
              </th>
              <th
                className={classes.thTag}
                //style={{ borderBottom: '1px solid lightgray' }}
                onClick={() => {
                  this.sortTable('paused');
                }}
              >
                Pause {sortBy === 'paused' && sortIcon}
              </th>
            </tr>
          </thead>
          <tbody>
            {this.getDeviceRows(
              groupMap,
              true
            )}
          </tbody>
        </table>
      </div>
    );
    if (targetView === 'Desktop') {
      return tableForDesktop;
    } else {
      return (
        <div style={{ display: 'flex' }}>
          {table1}
          {table2}
        </div>
      );
    }
  };

  getDevicesNameTable = () => {
    let sortIcon;
    const { sortDirection, sortBy } = this.state;
    if (sortDirection === 'desc') {
      sortIcon = <FaSortUp fontSize={'12px'} />;
    } else if (sortDirection === 'asc') {
      sortIcon = <FaSortDown fontSize={'12px'} />;
    }
    let table = (
      <div style={{ float: 'left' }}>
        <table
          className={classes.devTable}
          style={{ borderBottom: '1px solid lightgray' }}
          cellPadding="0"
          cellSpacing="0"
        >
          <thead>
            <tr className={classes.trTag}>
              <th
                style={{
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'left',
                  padding: '16px',
                  color: 'grey',
                  borderBottom: '1px solid lightgrey',
                }}
                onClick={() => {
                  this.sortTable('deviceName');
                }}
              >
                Device Name {sortBy === 'deviceName' && sortIcon}
              </th>
            </tr>
          </thead>
          <tbody>
            {this.getDeviceNameRows()}
          </tbody>
        </table>
      </div>
    );
    return table;
  };

  cancelGroupName() {
    this.setState({
      groupName: '',
      isInvalidGroupName: false,
      deviceMacs: new Map()
    });
  }

  updateFocus = (val) => {
    this.setState({ isFocused: val });
  }

  render() {

    let arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrow) {
      arrow = <MdKeyboardArrowUp color={'gray'} size={'30px'} />;
    } else {
      arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    }

    const isLoading = this.props.createDeviceGroupLoading ||
      this.props.loading ||
      this.props.devicesByEquipmentLoading ||
      this.props.adidLoading ||
      (this.props.wan && this.props.wan.checkingWan);

    return (
      <Box>
        <div className={classes.showDesktop}>
          <div className={classes.CreateGroupComponent}>
            <Collapsible
              transitionTime={100}
              onOpening={() => {
                this.openHandler();
              }}
              onClosing={() => {
                this.closeHandler();
              }}
              trigger={
                <Box>
                  <div className={classes.CreateGroupComponentCollapse}>
                    <div className={classes.TitleArea}>
                      <h3 style={{ paddingRight: 20, whiteSpace: 'pre' }}>
                        Create Group
                      </h3>
                      <button
                        id="creategrouparrow"
                        className={classes.OpenCloseButton}
                        style={{ float: 'right' }}
                        aria-label="open arrow"
                      >
                        {arrow}
                      </button>
                    </div>

                    <div className={classes.HorizontalSeparator} />
                  </div>
                </Box>
              }
            >
              <div style={{ display: 'flex' }}>
                <label style={{ paddingTop: 17, paddingLeft: '16px' }}>Group Name</label>
                <div>
                  <input className={classes.GroupNameInput} type="text" id="groupName" name="groupName"
                    aria-label="group name"
                    minlength="7"
                    maxLength="30"
                    placeholder="Enter the name"
                    required
                    value={this.state.groupName}
                    onChange={this.handleGroupNameChange}
                    onFocus={() => this.updateFocus(true)}
                    onBlur={() => this.updateFocus(false)}
                    // autofocus='true'
                    style={{ borderColor: this.state.isInvalidGroupName ? 'red' : this.state.groupName.length ? '#86A8DF' : '' }}
                  />
                  <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative' }}>
                    <div id='GroupNameError' style={this.state.isInvalidGroupName ? { color: 'red', fontSize: 12, marginLeft: 10 } : { display: 'none' }} > {this.state.groupNameError}</div>
                    {(!this.state.isInvalidGroupName || !this.state.isWarning || (this.state.groupName.length >= 30)) && this.state.isFocused && <div className={classes.groupNameLength} style={{ justifyContent: 'flex-end', position: 'absolute', right: '0px' }}>
                      <span style={this.state.groupName.length > 30 ? { color: 'red' } : {}}>{this.state.groupName.length}</span>/30
                    </div>}
                  </div>
                </div>
                {(this.state.groupName.length > 0 || this.state.isInvalidGroupName) &&
                  <span style={{ margin: '15px 10px 10px 10px' }}>
                    <button
                      id="createGroupButton"
                      style={{ background: 'none', border: 'none', marginLeft: '10px', marginRight: '5px' }}
                      title="Create Group"
                      disabled={(this.state.isInvalidGroupName && this.state.isWarning === false) || isLoading}
                      onClick={this.createGroupHandler}>
                      <FaCheck color={(this.state.isInvalidGroupName && this.state.isWarning === false) || isLoading ? 'gray' : 'green'} />

                    </button>
                    <button style={{ background: 'none', border: 'none' }}
                      onClick={this.cancelGroupName}
                      id="cancelGroupName"
                      title="Cancel Group"><FaTimes color={'red'}
                      /></button>
                  </span>
                }
                <br />
              </div>

              <div className={classes.Spacer} />
              <div className={classes.showDesktop}>{this.getDevicesTable('Desktop')}</div>

              <Modal
                show={this.props.createDeviceGroupError}
                modalClosed={this.successErrorResetHandler}
              >
                <Error id={'CreateGroupError'} showOldView />
              </Modal>
              <Modal
                show={this.props.createDeviceGroupSuccess}
                modalClosed={this.successErrorResetHandler}
              >
                <Success id={'CreateGroupSuccess'} />
              </Modal>
              <Modal
                id={'CreateGroupCancelBtn'}
                deviceGroupConfirmation="true"
                show={this.state.confirmModal}
                modalClosed={this.confirmModalCancelHandler}
              >
                <Confirm
                  id={'CreateGroupConfirm'}
                  deviceGroupConfirmation="true"
                  action={this.state.action}
                  result={this.state.result}
                  confirm={this.confirmModalConfirmHandler}
                  cancel={this.confirmModalCancelHandler}
                  cancelButtonLabel="Cancel"
                  confirmButtonLabel="Yes"
                />
              </Modal>
            </Collapsible>
          </div>
        </div>
        <div className={classes.showMobile}>
          <div className={classes.CreateGroupComponent}>
            <Collapsible
              transitionTime={100}
              onOpening={() => {
                this.openHandler();
              }}
              onClosing={() => {
                this.closeHandler();
              }}
              trigger={
                <Box>
                  <div className={classes.CreateGroupComponentCollapse}>
                    <div className={classes.TitleArea}>
                      <h3 style={{ paddingRight: 20 }}>Create Group</h3>
                      <button
                        className={classes.OpenCloseButton}
                        style={{ float: 'right' }}
                        aria-label="open arrow"
                      >
                        {arrow}
                      </button>
                    </div>

                    <div className={classes.HorizontalSeparator} />
                  </div>
                </Box>
              }
            >
              <div className={classes.GroupNameDiv}>
                <div style={{ display: 'flex' }}>
                  <label style={{ paddingTop: 17 }}>Group Name</label>
                  <div>
                    <input className={classes.GroupNameInput} type="text" id="groupName" name="groupName"
                      aria-label="group name"
                      minlength="7"
                      placeholder="Enter the name"
                      required
                      value={this.state.groupName}
                      onChange={this.handleGroupNameChange}
                      onFocus={() => this.updateFocus(true)}
                      onBlur={() => this.updateFocus(false)}
                      // autofocus='true'
                      style={{ borderColor: this.state.isInvalidGroupName ? 'red' : this.state.groupName.length ? '#86A8DF' : '' }}
                    />
                    <div id='GroupNameError' style={this.state.isInvalidGroupName ? { color: 'red', fontSize: 12, marginLeft: 10, width: 155 } : { display: 'none' }} > {this.state.groupNameError}</div>
                    {(!this.state.isInvalidGroupName || this.state.groupName.length > 30) && this.state.isFocused && <div className={classes.groupNameLength}>
                      <span style={this.state.groupName.length > 30 ? { color: 'red' } : {}}>{this.state.groupName.length}</span>/30
                    </div>}
                  </div>
                  {(this.state.groupName.length > 0 || this.state.isInvalidGroupName) ?
                    <span style={{ margin: '5px 0px 0px 0px', paddingTop: 12 }}>
                      <button
                        id="createGroupButton"
                        style={{ background: 'none', border: 'none', marginLeft: '10px', marginRight: '0px' }}
                        title="Create Group"
                        disabled={this.state.isInvalidGroupName || isLoading}
                        onClick={this.createGroupHandler}>
                        <FaCheck color={(
                          this.state.isInvalidGroupName || isLoading) ? 'gray' : 'green'}
                        />

                      </button>
                      <button style={{ background: 'none', border: 'none' }}
                        onClick={this.cancelGroupName}
                        id="cancelGroupName"
                        title="Cancel Group"><FaTimes color={'red'}

                        /></button> </span> : <span />}
                </div>
              </div>

              <div className={classes.Spacer} />
              <div className={classes.showMobile}>{this.getDevicesTable('Mobile')}</div>
              <Modal
                show={this.props.createDeviceGroupError}
                modalClosed={this.successErrorResetHandler}
              >
                <Error showOldView />
              </Modal>
              <Modal
                show={this.props.createDeviceGroupSuccess}
                modalClosed={this.successErrorResetHandler}
              >
                <Success />
              </Modal>
              <Modal
                deviceGroupConfirmation="true"
                show={this.state.confirmModal}
                modalClosed={this.confirmModalCancelHandler}
              >
                <Confirm
                  deviceGroupConfirmation="true"
                  action={this.state.action}
                  result={this.state.result}
                  confirm={this.confirmModalConfirmHandler}
                  cancel={this.confirmModalCancelHandler}
                  cancelButtonLabel="Cancel"
                  confirmButtonLabel="Yes"
                />
              </Modal>
            </Collapsible>
          </div>
        </div>
      </Box>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    devicesByEquipmentLoading: state.devices.loading,
    adidLoading: state.devices.loading,
    advancedDeviceIds: state.devices.advancedDeviceIds,
    realWan: state.wan.realWan,
    equipment: state.equipment,
    createDeviceGroupError: state.deviceGroups.createDeviceGroupError,
    createDeviceGroupSuccess: state.deviceGroups.createDeviceGroupSuccess,
    createDeviceGroupLoading: state.deviceGroups.createDeviceGroupLoading,
    wan: state.wan,
    apiNotFound: state.devices.apiNotFound,
    errorStatus: state.devices.errorStatus
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCreateDeviceGroup: (group) => dispatch(actions.createDeviceGroup(group)),
    onResetCreateDeviceGroupSuccessError: () =>
      dispatch(actions.resetCreateDeviceGroupSuccessError()),
    onGetAdvancedDeviceIds: (deviceMacs) => {
      dispatch(actions.getAdvancedDeviceIds(deviceMacs));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(CreateGroup, api));
